import React from 'react'

const CamposUbicacion = ({ state, handleInputChangeEnlace, extraerDatosDeEnlaceGoogleMaps }) => {
  return (
    <div className="space-y-4 p-4 bg-red-50 rounded-lg border border-red-200">
      <h4 className="font-semibold text-red-800 flex items-center gap-2">
        <i className="fas fa-map-marker-alt"></i>
        Agregar Ubicación
      </h4>
      
      <div className="p-4 bg-white rounded-lg border border-gray-200">
        <div className="flex items-center gap-3 mb-3">
          <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
            <i className="fas fa-map text-blue-600"></i>
          </div>
          <div>
            <h5 className="font-medium text-gray-800">Pegar enlace de Google Maps</h5>
            <p className="text-sm text-gray-600">La forma más fácil de agregar una ubicación</p>
          </div>
        </div>
        
        <div className="space-y-2">
          <label className="block text-sm font-medium text-gray-700">
            Enlace de Google Maps
          </label>
          <div className="relative">
            <i className="fas fa-link absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
            <input
              type="url"
              placeholder="https://maps.google.com/maps?q=... o https://goo.gl/maps/..."
              value={state.enlace.enlaceGoogleMaps || ''}
              onChange={(e) => {
                handleInputChangeEnlace('enlaceGoogleMaps', e.target.value)
                if (e.target.value.trim()) {
                  extraerDatosDeEnlaceGoogleMaps(e.target.value)
                }
              }}
              className={`w-full pl-10 pr-3 py-3 border-2 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-base ${
                state.enlace.enlaceGoogleMaps && 
                (state.enlace.enlaceGoogleMaps.includes('maps.google') || 
                 state.enlace.enlaceGoogleMaps.includes('goo.gl/maps') ||
                 state.enlace.enlaceGoogleMaps.includes('google.com/maps')) 
                  ? 'border-green-500' 
                  : 'border-gray-300'
              }`}
            />
          </div>
        </div>
        
        {state.enlace.enlaceGoogleMaps && 
          (state.enlace.enlaceGoogleMaps.includes('maps.google') || 
           state.enlace.enlaceGoogleMaps.includes('goo.gl/maps') ||
           state.enlace.enlaceGoogleMaps.includes('google.com/maps')) && (
          <div className="mt-3 p-3 bg-green-50 border border-green-200 rounded-lg">
            <div className="flex items-center gap-2 text-green-800">
              <i className="fas fa-check-circle"></i>
              <span className="font-medium">Enlace válido detectado</span>
            </div>
            <p className="text-sm text-green-700 mt-1">
              Los datos se extraerán automáticamente del enlace
            </p>
          </div>
        )}
      </div>
      
      {/* Instrucciones mejoradas */}
      <div className="p-4 bg-blue-50 rounded-lg border border-blue-200">
        <h6 className="font-medium text-blue-800 mb-2 flex items-center gap-2">
          <i className="fas fa-info-circle"></i>
          ¿Cómo obtener el enlace?
        </h6>
        <div className="space-y-2 text-sm text-blue-700">
          <div className="flex items-start gap-2">
            <span className="bg-blue-200 text-blue-800 rounded-full w-5 h-5 flex items-center justify-center text-xs font-bold mt-0.5">1</span>
            <span>Abre <strong>Google Maps</strong> en tu navegador</span>
          </div>
          <div className="flex items-start gap-2">
            <span className="bg-blue-200 text-blue-800 rounded-full w-5 h-5 flex items-center justify-center text-xs font-bold mt-0.5">2</span>
            <span>Busca el lugar que quieres compartir</span>
          </div>
          <div className="flex items-start gap-2">
            <span className="bg-blue-200 text-blue-800 rounded-full w-5 h-5 flex items-center justify-center text-xs font-bold mt-0.5">3</span>
            <span>Haz clic en <strong>"Compartir"</strong> y luego <strong>"Copiar enlace"</strong></span>
          </div>
          <div className="flex items-start gap-2">
            <span className="bg-blue-200 text-blue-800 rounded-full w-5 h-5 flex items-center justify-center text-xs font-bold mt-0.5">4</span>
            <span>Pega el enlace en el campo de arriba</span>
          </div>
        </div>
      </div>
      
      {/* Campos automáticos generados (solo lectura) */}
      {(state.enlace.nombreLugar || state.enlace.direccion) && (
        <div className="p-4 bg-gray-50 rounded-lg border border-gray-200">
          <h6 className="font-medium text-gray-800 mb-2 flex items-center gap-2">
            <i className="fas fa-robot"></i>
            Información extraída automáticamente
          </h6>
          <div className="space-y-2 text-sm">
            {state.enlace.nombreLugar && (
              <div className="flex items-center gap-2">
                <i className="fas fa-building text-gray-500"></i>
                <span className="font-medium text-gray-600">Lugar:</span>
                <span className="text-gray-800">{state.enlace.nombreLugar}</span>
              </div>
            )}
            {state.enlace.direccion && (
              <div className="flex items-center gap-2">
                <i className="fas fa-map-marker-alt text-gray-500"></i>
                <span className="font-medium text-gray-600">Dirección:</span>
                <span className="text-gray-800">{state.enlace.direccion}</span>
              </div>
            )}
            {state.enlace.latitud && state.enlace.longitud && (
              <div className="flex items-center gap-2">
                <i className="fas fa-crosshairs text-gray-500"></i>
                <span className="font-medium text-gray-600">Coordenadas:</span>
                <span className="text-gray-800">{state.enlace.latitud}, {state.enlace.longitud}</span>
              </div>
            )}
          </div>
        </div>
      )}
      
      {/* Vista previa del enlace */}
      {state.enlace.enlaceGoogleMaps && (
        <div className="p-3 bg-red-100 rounded-lg">
          <p className="text-sm text-red-800 mb-2">
            <i className="fas fa-eye mr-2"></i>
            Vista previa del enlace:
          </p>
          <a
            href={state.enlace.enlaceGoogleMaps}
            target="_blank"
            rel="noopener noreferrer"
            className="text-red-600 hover:text-red-700 text-sm break-all inline-flex items-center gap-2"
          >
            <i className="fas fa-external-link-alt"></i>
            Abrir en Google Maps
          </a>
        </div>
      )}
    </div>
  )
}

export default CamposUbicacion 